/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadSharesControllerCreateMutationResponse, ThreadSharesControllerCreate400, ThreadSharesControllerCreate401, ThreadSharesControllerCreate403 } from "../../models/threadsController/ThreadSharesControllerCreate";

function getThreadSharesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/thread-shares` as const }  
  return res
}

/**
 * @description Notify the given people that the thread was shared with them. Only the owner may share, and only people who can read every scope the thread used are notified; nothing is recorded.
 * @summary Share a thread
 * {@link /api/v1/thread-shares}
 */
export async function threadSharesControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadSharesControllerCreateMutationResponse, ResponseErrorConfig<ThreadSharesControllerCreate400 | ThreadSharesControllerCreate401 | ThreadSharesControllerCreate403>, unknown>({ method : "POST", url : getThreadSharesControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}